import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { GRID_BASE_CLASSNAME } from './Constants';
import { createGrid } from './Grid';
createComponents(".".concat(GRID_BASE_CLASSNAME), createGrid, NO_PATTERN_BUSINESS_LOGIC);
